export default "__VITE_ASSET__BzrtkDPS__"